import store from 'store'

const el = '[data-content=HoldetsRoundCounterOverlay]'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((HoldetsRoundCounterOverlayDOM) => {
            if (HoldetsRoundCounterOverlayDOM.dataset.teamid) {
                const teamId = HoldetsRoundCounterOverlayDOM.dataset.teamid
                const maxRegistrationCount = parseInt(HoldetsRoundCounterOverlayDOM.dataset.maxRegistrationCount)
            
                store.commit('main/set_page_overlay_content_data', { teamId, maxRegistrationCount })
            }
        })
    }
}
